document.addEventListener("DOMContentLoaded", () => {
  const svgElement = document.querySelector(".header__heading-logo");
  const targetMobile = document.querySelector("#section__about-us");
  const targetDesktop = document.querySelector(".gallery__about-us");
  const targetElement2 = document.querySelector(".section__collection-list");

  // スクロール判定処理
  const handleScroll = () => {
    const windowWidth = window.innerWidth;

    // 1つ目のターゲット要素
    const targetElement1 = windowWidth <= 767 ? targetMobile : targetDesktop;
    if (targetElement1) {
      const targetRect1 = targetElement1.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // 要素が画面内に完全に表示されている場合
      if (targetRect1.top < windowHeight * 0.2 && targetRect1.bottom > windowHeight * 0.1) {
        svgElement.classList.add("color-turning1");
      } else {
        svgElement.classList.remove("color-turning1");
      }
    }

    // 2つ目のターゲット要素
    if (targetElement2) {
      const targetRect2 = targetElement2.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      // 要素が画面内に完全に表示されている場合
      if (targetRect2.top < windowHeight * 0.2 && targetRect2.bottom > windowHeight * 0.5) {
        svgElement.classList.add("color-turning2");
      } else {
        svgElement.classList.remove("color-turning2");
      }
    }
  };

  // リサイズ時の再チェック
  const handleResize = () => {
    handleScroll();
  };

  // スクロールとリサイズイベントを監視
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleResize);

  // 初回実行
  handleScroll();
});